import {useMediaQuery} from "react-responsive";
import {mobileMaxWidthQuery} from "../../../core/layout/responsive";
import React from "react";
import "../../evaluering/evaluering/evalueringSektion.scss";
import {KompetenceSektionModel} from "../../../core/sharedmodels/evaluering/kompetenceSektionModel";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {KompetenceEvalueringSpoergsmaal} from "../spoergsmaal/kompetenceEvalueringSpoergsmaal";
import {KompetenceSvarModel} from "../../../core/sharedmodels/evaluering/KompetencesvarModel";
import {DeleteEvalueringSvarModel} from "../../../services/api/logbogEvaluering/deleteEvalueringSvarModel";
import useUser from "../../../core/hooks/useUser";
import Tooltip from "../../../core/components/tooltips/Tooltip";

export interface KompetenceEvalueringSektionProps {
    sektion: KompetenceSektionModel;
    finishSektion: boolean;
    kompetenceEvalueringId: string;
    updateSvarCallback: (svar: KompetenceSvarModel) => void;
    deleteSvarCallback: (svar: DeleteEvalueringSvarModel) => void;
    finishSectionDisable: boolean;
    evalueringIndsendt: boolean;
    answerUpdateLoading: boolean;
    requiredAndPassed?: boolean;
    nextButtonClickedCallback: () => void;
    setShowGodkendModalCallback: (show: boolean) => void;
}

export function KompetenceEvalueringSektion({
                                                sektion,
                                                finishSektion,
                                                nextButtonClickedCallback,
                                                setShowGodkendModalCallback,
                                                finishSectionDisable,
                                                evalueringIndsendt,
                                                kompetenceEvalueringId,
                                                updateSvarCallback,
                                                deleteSvarCallback,
                                                requiredAndPassed,
                                            }: KompetenceEvalueringSektionProps) {
    const IsMobile = useMediaQuery(mobileMaxWidthQuery);
    const godkendModalId = "kompetenceEvalueringGodkend";
    const {currentUser} = useUser()

    return (
        <div className={`max-w-600 d-flex card-body margin-top-0 wrap ${IsMobile ? "" : ""} "collapse show `}
             id={sektion.id}>
            {sektion.subTitle &&
                <h4 className={"subtle margin-bottom-m"}>{sektion.subTitle}</h4>
            }
            <div className={"d-flex flex-full-width"}>
                {sektion.tekst &&
                    <p className={"pre-line"}>{sektion.tekst}</p>
                }
            </div>
            <div>
                {sektion.spoergsmaal.sortBy(x => x.sortOrder).map(spoergsmaal => (
                    <div className={`margin-bottom-m ${IsMobile ? "" : "min-w-550"}`}
                         key={spoergsmaal.id}>
                        <div className="spoergsmaal">
                            <KompetenceEvalueringSpoergsmaal
                                readOnly={!spoergsmaal.laegerKanBesvare && currentUser.IsLaege()}
                                updateSvarCallback={updateSvarCallback}
                                deleteSvarCallback={deleteSvarCallback}
                                kompetenceEvalueringId={kompetenceEvalueringId}
                                sektionId={sektion.id}
                                spoergsmaal={spoergsmaal}
                                indsendt={evalueringIndsendt}
                            />
                        </div>
                    </div>
                ))}
                {(!finishSektion && !sektion.includedInProgress) &&
                    <button className="btn btn-primary d-flex margin-top-s"
                            onClick={() => nextButtonClickedCallback()}>
                        {Localizer.global_next()}
                    </button>
                }
                {finishSektion &&
                    <Tooltip show={finishSectionDisable} title={currentUser.IsLaege() ? Localizer.evalueringPage_duKanIkkeAfslutteKvSkema() : Localizer.evalueringPage_allePaakraevedeSpoergsmaalSkalBesvares()}>
                        <button className="btn btn-primary"
                                onClick={() => setShowGodkendModalCallback(true)}
                                disabled={finishSectionDisable}
                                data-toggle="modal"
                                data-target={`#${godkendModalId}`}>
                            {Localizer.global_afslut()}
                        </button>
                    </Tooltip>
                }
            </div>
        </div>
    );
}
